/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Reviews_Reviewedon2Inputs */

const id_offerdetail_reviews_reviewedon2 = /** @type {(inputs: Offerdetail_Reviews_Reviewedon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diulas pada`)
};

const ms_offerdetail_reviews_reviewedon2 = /** @type {(inputs: Offerdetail_Reviews_Reviewedon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diulas pada`)
};

const da_offerdetail_reviews_reviewedon2 = /** @type {(inputs: Offerdetail_Reviews_Reviewedon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmeldt den`)
};

const de_offerdetail_reviews_reviewedon2 = /** @type {(inputs: Offerdetail_Reviews_Reviewedon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewertet am`)
};

const en_us2_offerdetail_reviews_reviewedon2 = /** @type {(inputs: Offerdetail_Reviews_Reviewedon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reviewed on`)
};

const es_es2_offerdetail_reviews_reviewedon2 = /** @type {(inputs: Offerdetail_Reviews_Reviewedon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reseñado el`)
};

const es_mx2_offerdetail_reviews_reviewedon2 = /** @type {(inputs: Offerdetail_Reviews_Reviewedon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reseñado el`)
};

const fil_offerdetail_reviews_reviewedon2 = /** @type {(inputs: Offerdetail_Reviews_Reviewedon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na-review noong`)
};

const fr_offerdetail_reviews_reviewedon2 = /** @type {(inputs: Offerdetail_Reviews_Reviewedon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avis publié le`)
};

const it_offerdetail_reviews_reviewedon2 = /** @type {(inputs: Offerdetail_Reviews_Reviewedon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recensito il`)
};

const hu_offerdetail_reviews_reviewedon2 = /** @type {(inputs: Offerdetail_Reviews_Reviewedon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Értékelve`)
};

const nl_offerdetail_reviews_reviewedon2 = /** @type {(inputs: Offerdetail_Reviews_Reviewedon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beoordeeld op`)
};

const no_offerdetail_reviews_reviewedon2 = /** @type {(inputs: Offerdetail_Reviews_Reviewedon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Omtalt`)
};

const pl_offerdetail_reviews_reviewedon2 = /** @type {(inputs: Offerdetail_Reviews_Reviewedon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recenzja z dnia`)
};

const pt_br2_offerdetail_reviews_reviewedon2 = /** @type {(inputs: Offerdetail_Reviews_Reviewedon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisado em`)
};

const pt_offerdetail_reviews_reviewedon2 = /** @type {(inputs: Offerdetail_Reviews_Reviewedon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avaliado em`)
};

const ro_offerdetail_reviews_reviewedon2 = /** @type {(inputs: Offerdetail_Reviews_Reviewedon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recenzat pe`)
};

const fi_offerdetail_reviews_reviewedon2 = /** @type {(inputs: Offerdetail_Reviews_Reviewedon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arvosteltu`)
};

const sv_offerdetail_reviews_reviewedon2 = /** @type {(inputs: Offerdetail_Reviews_Reviewedon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recenserad`)
};

const vi_offerdetail_reviews_reviewedon2 = /** @type {(inputs: Offerdetail_Reviews_Reviewedon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã đánh giá vào`)
};

const tr_offerdetail_reviews_reviewedon2 = /** @type {(inputs: Offerdetail_Reviews_Reviewedon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yorum tarihi`)
};

const cs_offerdetail_reviews_reviewedon2 = /** @type {(inputs: Offerdetail_Reviews_Reviewedon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recenzováno`)
};

const bg_offerdetail_reviews_reviewedon2 = /** @type {(inputs: Offerdetail_Reviews_Reviewedon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ревюирано на`)
};

const ru_offerdetail_reviews_reviewedon2 = /** @type {(inputs: Offerdetail_Reviews_Reviewedon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обзор от`)
};

const uk_offerdetail_reviews_reviewedon2 = /** @type {(inputs: Offerdetail_Reviews_Reviewedon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Відгук залишено`)
};

const ar_offerdetail_reviews_reviewedon2 = /** @type {(inputs: Offerdetail_Reviews_Reviewedon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تمت المراجعة في`)
};

const hi_offerdetail_reviews_reviewedon2 = /** @type {(inputs: Offerdetail_Reviews_Reviewedon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समीक्षा की गई`)
};

const th_offerdetail_reviews_reviewedon2 = /** @type {(inputs: Offerdetail_Reviews_Reviewedon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รีวิวเมื่อ`)
};

const ja_offerdetail_reviews_reviewedon2 = /** @type {(inputs: Offerdetail_Reviews_Reviewedon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レビュー日`)
};

const zh_cn2_offerdetail_reviews_reviewedon2 = /** @type {(inputs: Offerdetail_Reviews_Reviewedon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发表于`)
};

const zh_hant1_offerdetail_reviews_reviewedon2 = /** @type {(inputs: Offerdetail_Reviews_Reviewedon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`發表於`)
};

const ko_offerdetail_reviews_reviewedon2 = /** @type {(inputs: Offerdetail_Reviews_Reviewedon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`리뷰 작성일`)
};

/**
* | output |
* | --- |
* | "Reviewed on" |
*
* @param {Offerdetail_Reviews_Reviewedon2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_reviews_reviewedon2 = /** @type {((inputs?: Offerdetail_Reviews_Reviewedon2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Reviews_Reviewedon2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_reviews_reviewedon2(inputs)
	if (locale === "ms") return ms_offerdetail_reviews_reviewedon2(inputs)
	if (locale === "da") return da_offerdetail_reviews_reviewedon2(inputs)
	if (locale === "de") return de_offerdetail_reviews_reviewedon2(inputs)
	if (locale === "en-US") return en_us2_offerdetail_reviews_reviewedon2(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_reviews_reviewedon2(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_reviews_reviewedon2(inputs)
	if (locale === "fil") return fil_offerdetail_reviews_reviewedon2(inputs)
	if (locale === "fr") return fr_offerdetail_reviews_reviewedon2(inputs)
	if (locale === "it") return it_offerdetail_reviews_reviewedon2(inputs)
	if (locale === "hu") return hu_offerdetail_reviews_reviewedon2(inputs)
	if (locale === "nl") return nl_offerdetail_reviews_reviewedon2(inputs)
	if (locale === "no") return no_offerdetail_reviews_reviewedon2(inputs)
	if (locale === "pl") return pl_offerdetail_reviews_reviewedon2(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_reviews_reviewedon2(inputs)
	if (locale === "pt") return pt_offerdetail_reviews_reviewedon2(inputs)
	if (locale === "ro") return ro_offerdetail_reviews_reviewedon2(inputs)
	if (locale === "fi") return fi_offerdetail_reviews_reviewedon2(inputs)
	if (locale === "sv") return sv_offerdetail_reviews_reviewedon2(inputs)
	if (locale === "vi") return vi_offerdetail_reviews_reviewedon2(inputs)
	if (locale === "tr") return tr_offerdetail_reviews_reviewedon2(inputs)
	if (locale === "cs") return cs_offerdetail_reviews_reviewedon2(inputs)
	if (locale === "bg") return bg_offerdetail_reviews_reviewedon2(inputs)
	if (locale === "ru") return ru_offerdetail_reviews_reviewedon2(inputs)
	if (locale === "uk") return uk_offerdetail_reviews_reviewedon2(inputs)
	if (locale === "ar") return ar_offerdetail_reviews_reviewedon2(inputs)
	if (locale === "hi") return hi_offerdetail_reviews_reviewedon2(inputs)
	if (locale === "th") return th_offerdetail_reviews_reviewedon2(inputs)
	if (locale === "ja") return ja_offerdetail_reviews_reviewedon2(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_reviews_reviewedon2(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_reviews_reviewedon2(inputs)
	return ko_offerdetail_reviews_reviewedon2(inputs)
});
export { offerdetail_reviews_reviewedon2 as "offerDetail.reviews.reviewedOn" }